import util from '@/Utils/util';

import type { AllowanceFormGroup, BalanceFormRow } from '../Partners/Subsidy/budgetBalanceForm';

export type EditableBudgetRow = Omit<BalanceFormRow, 'amount' | 'startBudgetAmount'> & {
  amount: number | null;
  startBudgetAmount: number | null;
};

export type EditableBudgetGroup = Omit<AllowanceFormGroup, 'balances'> & {
  balances: EditableBudgetRow[];
};

export type PartnerMemberBudgets = {
  groups: EditableBudgetGroup[];
};

export type PartnerMemberBudgetChanges = {
  updatedIds: number[];
  removedIds: number[];
};

export type PartnerBudgetBalancePatch = Partial<
  Pick<EditableBudgetRow, 'amount' | 'beginningDate' | 'suspensionDate' | 'preAuthorizationNumber'>
>;

export const buildEmptyBudgetChanges = (): PartnerMemberBudgetChanges => ({ updatedIds: [], removedIds: [] });

export const formatBudgetDate = (value: unknown) => (value ? util.formatDateTime(value, 'YYYY-MM-DD') || '' : '');

export const isBlankBudgetRow = (row: EditableBudgetRow) =>
  row.id == null &&
  !formatBudgetDate(row.beginningDate) &&
  !formatBudgetDate(row.suspensionDate) &&
  row.amount == null &&
  !(row.preAuthorizationNumber ?? '').trim();

export const toBalanceFormRow = (row: EditableBudgetRow): BalanceFormRow => ({
  key: row.key,
  id: row.id,
  amount: row.amount ?? 0,
  overrideRenewAmount: row.overrideRenewAmount,
  startBudgetAmount: row.id == null ? (row.amount ?? 0) : (row.startBudgetAmount ?? row.amount ?? 0),
  beginningDate: formatBudgetDate(row.beginningDate),
  suspensionDate: formatBudgetDate(row.suspensionDate),
  preAuthorizationNumber: row.preAuthorizationNumber ?? '',
});

export const buildBlankBudgetRow = (): EditableBudgetRow => ({
  key: `new-${crypto.randomUUID()}`,
  id: null,
  amount: null,
  overrideRenewAmount: null,
  startBudgetAmount: null,
  beginningDate: '',
  suspensionDate: '',
  preAuthorizationNumber: '',
});
